import { FooterOther } from "../../Footer/FooterOther";
import { Topbar } from "../../Topbar/Topbar";
import "./Faq.css";
import { Helmet } from "react-helmet-async";

const faqData = [
  {
    question: "What is Yuva Quest?",
    answer:
      "Yuva Quest is an interactive learning platform designed for kids and teens to explore India’s culture through engaging quests, videos, and quizzes.",
  },
  {
    question: "What do we mean by Quests?",
    answer:
      "When we say quests, we refer to the journey a child experiences on the platform and uses maps and quizzes to explore the contents and learn through them.",
  },
  {
    question: "Who can use Yuva Quest?",
    answer:
      "The platform is ideal for young learners, especially children and teenagers, who enjoy interactive activities and want to learn through fun quests. They get trophies and certificates and virtual rewards when they solve the quizzes.",
  },
  {
    question: "What kind of activities are available on Yuva Quest?",
    answer:
      "Yuva Quest offers a variety of activities such as cultural quests, quizzes, and adventure-based learning that help users engage with educational content in an enjoyable way.",
  },
  {
    question: "Can I access Yuva Quest on different devices?",
    answer:
      "Yes! Yuva Quest is designed to be accessible on multiple devices including laptops, smartphones, and tablets, so you can explore activities anytime, anywhere.",
  },
  {
    question: "What do children learn from Yuva Quest?",
    answer:
      "Yuva Quest uses quests, maps, and quizzes to teach children about India's festivals, temples, monuments, shlokas, ancient figures, and Freedom Fighters.",
  },
  {
    question: "How to keep children motivated to continue using Yuva Quest?",
    answer:
      "After watching an episode, children take quizzes based on what they learned. Upon successfully completing a quest, they earn virtual certificates and trophies to boost their motivation.",
  },
  {
    question: "Is the content age appropriate for kids?",
    answer:
      "Yes, every content material in Yuva Quest is child friendly and age appropriate for kids and teenagers. The words/languages used and the visuals are all ensured to be safe for young audiences and does not impart any bad influence on the delicate mind of a child.",
  },
  {
    question:
      "How can parents/teachers/schools evaluate a child’s progress through the Yuva Quest platform?",
    answer:
      "When parents or schools enroll a child in Yuva Quest, it is natural to want to track their growth. Our platform includes built-in tracking tools that generate detailed progress reports, allowing parents and teachers to monitor exactly what the child has learned.",
  },
  {
    question: "How will Yuva Quest help my child?",
    answer:
      "Teaching children about India's vast heritage, including its temples, festivals, and history, can be difficult with traditional methods. It often becomes a chore rather than a joy. Yuva Quest changes the narrative by making learning fun. Through gamified quests, quizzes, and rewards like virtual trophies, we capture children’s attention. We help pass on India's rich legacy to the younger generation in a language they understand.",
  },
  {
    question: "How to start the enrollment process?",
    answer:
      "Well, it’s simple. All you have to do is register into the platform with your email address and fill up all the required fields in the registration page, make the payment and you are good to go!",
  },
  {
    question: "How many kids can one parent enroll?",
    answer: "If you are a parent then you can register up to 5 kids.",
  },
  {
    question: "How many kids can a teacher enroll into the program?",
    answer:
      "Teacher can enrol based on their subscriptions, for this contact support@yuvaquest.com",
  },
  {
    question: "How many kids can a school enroll into the program?",
    answer:
      "School can enrol based on their subscriptions, for this contact support@yuvaquest.com",
  },
  {
    question: "How many kids can an organisation enroll into the program?",
    answer:
      "Organisation can enrol based on their subscriptions, for this contact support@yuvaquest.com",
  },
  {
    question: "Can a child enroll on their own?",
    answer:
      "Children will not be able to enroll on their own but need a parent or a teacher ID and email address for registration.",
  },
];

export const FaqPage = () => {
  return (
    <>
      <Helmet>
        <title>Frequently Asked Questions (FAQs) — Yuva Quest</title>
        <link rel="canonical" href="https://yuvaquest.com/about" />
        <meta
          name="description"
          content="Interactive quests for kids to explore Indian history, heroes, and gods. Learn, play, and connect with Indian roots!"
        />
      </Helmet>
      <div className="webUi my_custom_section ">
        <h2 className="webUi">FAQ</h2>
      </div>

      <div className="formdiv container ">
        <div className="accordion accordion-flush" id="faqAccordion">
          {faqData.map((item, index) => (
            <div className="accordion-item faq-item" key={index}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${
                    index !== 0 ? "collapsed" : ""
                  }`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#faq-${index}`}
                >
                  {item.question}
                </button>
              </h2>
              <div
                id={`faq-${index}`}
                className={`accordion-collapse collapse ${
                  index === 0 ? "show" : ""
                }`}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">{item.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
